import { PickListItem, JsonItem } from "../../../../shared/entities/pick-list/pick-list.entities";
import { CppForm } from "../../../../shared/entities/cpp-form/cpp-form";
import { plainToClass } from "class-transformer"
import { CppProposalForm } from "./cpp-proposal-form.form";

export class CppProposalFormPage {
    cppForm: CppForm;
    pickLists: JsonItem[];

    cppProposalForm: CppProposalForm;
    constructor(cppFormJson: any, pickLists: any) {
        this.cppForm = plainToClass(CppForm, <CppForm>cppFormJson);
        this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);

        this.cppProposalForm = new CppProposalForm(this.cppForm, this.pickLists);

        this.initializeDocumentCards();
    }

    viewInstructions(): void {
        let instructionsModal = $("#cpp-instructions-modal");
        instructionsModal.modal("show");
    }

    private initializeDocumentCards(): void {
        $(".document-view-btn").on("click", (e) => {
            let targetCard = $(e.currentTarget);
            let link = targetCard.data("link");
            let filename = targetCard.data("filename");
            this.viewDocument(filename, link);
        })
    }

    private viewDocument(fileName: string, docLink: string): void {
        let viewDocModal = $("#view-document-modal");
        if (viewDocModal) {
            viewDocModal.find("#filename").text(fileName);
            viewDocModal.find("#document-iframe").attr("src", docLink);
            viewDocModal.modal("show");
        }
    }
}